import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Aside from './components/aside';
import Home from './components/home';
import About from './components/about';
import Services from './components/services';
import Portfolio from './components/portfolio';
import Contact from './components/contact';
import Switcher from './components/switcher';
import Login from './components/Login';
import Dashboard from './components/dashboard';
import ProtectedRoute from './components/ProtectedRoute';

import './App.css';

function App() {
  return (
    <Router>
      <Aside />
      <div className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/contact" element={<Contact />} />

          <Route path="/login" element={<Login />} />

          {/* Protect the Dashboard route */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<h1>404 – Page Not Found</h1>} />
        </Routes>
      </div>
      <Switcher />
    </Router>
  );
}

export default App;